<template>
  <base-modal>
    <h3 class="prompt">{{ stakeholderPrompt3 }}</h3>
    <stakeholder-search
      ref="search"
      :autosearch="false"
      class="search--color search--tall"
      aria-label="Enter text to search lawmakers and policy influencers"
      placeholder="Search lawmakers and influencers" />
    <button
      class="btn--sm btn--yes"
      @click="searchAndClosePopup"
    >Search</button>
    <button
      class="btn--sm btn--empty btn--normal"
      @click="finishCampaign"
    >No, I'm finished</button>
  </base-modal>
</template>

<script>
import BaseModal from "WhoDoYouKnowComponents/modals/BaseModal.vue";
import Routes from "Constants/campaign/whodoyouknow/routeNames";
import StakeholderSearch from "WhoDoYouKnowComponents/StakeholderSearch.vue";
import { mapState } from "vuex";

export default {
  name: "StakeholderSearchPopup",
  components: {
    BaseModal,
    StakeholderSearch
  },
  computed: {
    ...mapState("campaign", {
      stakeholderPrompt3: state => state.contentStakeholderSearchPrompt3
    })
  },
  inject: {
    eventsBus: { from: "eventsBus" }
  },
  methods: {
    searchAndClosePopup() {
      this.$refs.search.search();
      this.eventsBus.$emit("hideStakeholderSearchPopup");
    },
    finishCampaign() {
      this.$router.push({ name: Routes.THANK_YOU });
      this.eventsBus.$emit("hideStakeholderSearchPopup");
    }
  }
};
</script>
<style lang="scss" scoped>
button {
  margin-top: 0;

  &:last-child {
    margin-top: -1rem;
    margin-bottom: -1rem;
  }
}
.modal__content {
  padding-bottom: 1rem;
}
</style>
